import { createMuiTheme } from '@material-ui/core/styles'
import webLibraryTheme from '@uacf/web-library/theme'

const theme = {
  ...webLibraryTheme,
  palette: {
    primary: {
      main: '#1ddd7c',
      contrastText: '#ffffff',
    },
  },
}

export default createMuiTheme(theme)
